import { render, staticRenderFns } from "./FormUpgrade.vue?vue&type=template&id=10fe1834&scoped=true"
import script from "./FormUpgrade.vue?vue&type=script&lang=js"
export * from "./FormUpgrade.vue?vue&type=script&lang=js"
import style0 from "./FormUpgrade.vue?vue&type=style&index=0&id=10fe1834&prod&lang=scss&scoped=true"
import style1 from "./FormUpgrade.vue?vue&type=style&index=1&id=10fe1834&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe1834",
  null
  
)

export default component.exports